// @flow

import { createSelector } from 'reselect';
import { sortBy } from 'lodash';

function getFriends(friends = {}, friendRequests = {}): Array<Friend | FriendRequest> {
  return [...Object.values(friends), ...sortBy(Object.values(friendRequests), 'sortOrder')];
}

const friendsSelector = createSelector(
  state => state.friends.friends,
  state => state.friendRequests.friendRequests,
  getFriends
);

export default friendsSelector;
